<template>
    <div>

        <!--begin::Label-->
        <label class="form-label fs-6 fw-bolder  text-dark"
               :class="item.is_required ? 'required' : ''"
        >
            <slot v-if="i18n.locale.value == 'ar'">
                {{item.label_ar}}
            </slot>
            <slot v-if="i18n.locale.value == 'en'">
                {{item.label}}
            </slot>
            <slot v-if="!item.is_required">&nbsp;{{$t('optional')}}</slot>
        </label>
        <!--end::Label-->
        <template v-if="item.type == 'Date' && item.date_picker_mode == 'Day'">
            <!--begin::Input-->
            <Field
                    v-model="item.value"
                    :name='item.model_key + item.key'
                    :label="i18n.locale.value == 'ar' ? item.label_ar : item.label"
                    :rules="$helpers.getValidationRules(item)"
                    v-slot='{ field }'>
                <flat-pickr v-bind='field'
                            :name='item.model_key + item.key'
                            class='form-control form-control-lg form-control-solid text-center w-100'
                            v-model="item.value"
                            :disabled="item.hasOwnProperty('is_editable') && !item.is_editable"
                            :config="getAppendDateConfig(item)"/>
            </Field>
            <!--begin::Input-->
        </template>

        <template v-if="item.type == 'Date' && item.date_picker_mode == 'Year'">
            <!--begin::Input-->
            <Field
                    v-model="item.value"
                    :name='item.model_key + item.key'
                    :label="i18n.locale.value == 'ar' ? item.label_ar : item.label"
                    :rules="$helpers.getValidationRules(item)"
                    v-slot='{ field }'>
                <VueDatePicker v-bind='field' year-picker :locale="i18n.locale.value" :cancelText="$t('cancel')"
                               :selectText="$t('choose')" :alt-position="customPosition"
                               :disabled="item.hasOwnProperty('is_editable') && !item.is_editable"
                               class='form-control form-control-lg form-control-solid text-center w-100'
                               :name='item.model_key + item.key'
                               v-model="item.value"/>
            </Field>
            <!--begin::Input-->
        </template>

        <template v-if="item.type == 'Date' && item.date_picker_mode == 'Month'">
            <!--begin::Input-->
            <Field
                    v-model="item.value"
                    :name='item.model_key + item.key'
                    :label="i18n.locale.value == 'ar' ? item.label_ar : item.label"
                    :rules="$helpers.getValidationRules(item)"
                    v-slot='{ field }'>
                <VueDatePicker v-bind='field' month-picker :locale="i18n.locale.value" :cancelText="$t('cancel')"
                               :format="'MM-yyyy'" :alt-position="customPosition"
                               :selectText="$t('choose')"
                               :disabled="item.hasOwnProperty('is_editable') && !item.is_editable"
                               class='form-control form-control-lg form-control-solid text-center w-100'
                               :name='item.model_key + item.key'
                               v-model="item.value"/>
            </Field>
            <!--begin::Input-->
        </template>

        <div class="fv-plugins-message-container">
            <div class="fv-help-block">
                <!--<span class="text-dark">({{item.type}})</span>-->
                <slot v-if="i18n.locale.value == 'ar'">
                    <span class="text-muted">{{item.hint_text_ar}}</span>
                </slot>
                <slot v-if="i18n.locale.value == 'en'">
                    <span class="text-muted">{{item.hint_text_en}}</span>
                </slot>
            </div>
        </div>
        <div class="fv-plugins-message-container">
            <div class="fv-help-block">
                <!--<ErrorMessage :name="item.model_key + item.key"/>-->
                <ErrorMessage :name="item.model_key + item.key" v-slot="{ message }">
                    <template v-if="item.validation_error_msg_ar  && i18n.locale.value == 'ar'">
                        <slot>
                            {{item.validation_error_msg_ar}}
                        </slot>
                    </template>
                    <template v-if="item.validation_error_msg  && i18n.locale.value == 'en'">
                        <slot>
                            {{item.validation_error_msg}}
                        </slot>
                    </template>
                    <template
                            v-if="!(item.validation_error_msg_ar  && i18n.locale.value == 'ar')  && !(item.validation_error_msg  && i18n.locale.value == 'en')">
                        <slot>
                            {{message}}
                        </slot>
                    </template>
                </ErrorMessage>
            </div>
        </div>
        <!--<div class="fv-plugins-message-container">-->
        <!--<div class="fv-help-block bg-primary text-white p-1">-->
        <!--{{$helpers.getValidationRules(item)}}-->
        <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script lang="ts">
  import { defineComponent, ref, reactive, toRefs, inject, computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { useRouter, useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import flatPickr from 'vue-flatpickr-component';
  import 'flatpickr/dist/flatpickr.css';
  import VueDatePicker from '@vuepic/vue-datepicker';
  import '@vuepic/vue-datepicker/dist/main.css';
  import moment from 'moment';


  export default defineComponent({
    name: 'FormDateInput',
    components: {
      Field,
      ErrorMessage,
      flatPickr,
      VueDatePicker,
    },
    props: {
      item: Object,
    },
    setup(props, context) {
      const helpers: any = inject('helpers');
      const i18n = useI18n();

      let currentItem: any = props.item;

      if (!currentItem.hasOwnProperty('date_picker_mode')) {
        currentItem.date_picker_mode = 'Day';
      }

      onMounted(() => {

        if (currentItem.value) {

          if (currentItem.date_picker_mode == 'Day') {
            let date: any = new Date(currentItem.value);
            if (isNaN(date)) {
              currentItem.value = currentItem.value.split('-').reverse().join('-');
            }
          }

          if (currentItem.date_picker_mode == 'Month') {
             if(typeof currentItem.value == "object"){
               return;
             }
            let month = currentItem.value.split('-')[0];
            let year = currentItem.value.split('-')[1];
            if (month && year) {
              currentItem.value = {
                'month': Number(month),
                'year': Number(year),
              };
            }
          }

          if (currentItem.date_picker_mode == 'Year') {
          }
        }
      });

      // currentItem.key = Math.random().toString(16);
      const state = reactive({
        item: currentItem,
      });


      const getAppendDateConfig = (item) => {
        let config: any = {
          enableTime: false,
          enableSeconds: false,
          disableMobile: true,
          dateFormat: 'Y-m-d',
        };
        if (item.initial_date) {
          config['defaultDate'] = item.initial_date;
        }
        if (item.min_date) {
          config['minDate'] = item.min_date;
        }
        if (item.max_date) {
          config['maxDate'] = item.max_date;
        }
        return config;
      };

      const customPosition = () => ({ top: -200, left: 0 });

      return {
        customPosition,
        ...toRefs(state),
        getAppendDateConfig,
        i18n,
        helpers,
      };
    },
  });
</script>
